<template>
  <div class="form-section mb-0">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de documento *</label>
          <FormSelect
            id="identifierType"
            v-model="form.identifierType"
            :items="identifierTypes"
            defaultOption="Elegir tipo de documento"
            :showError="v.identifierType.$error && !v.identifierType.required"
          />
          <FormError
            v-if="v.identifierType.$error && !v.identifierType.required"
            message="Tipo de documento es requerido"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Número de documento *</label>
          <input
            type="text"
            v-model.trim="form.identifier"
            autocomplete="off"
            placeholder="Ingresar número de documento"
            class="custom-form-control"
            :class="{ 'custom-form-control-error': v.identifier.$error }"
          />
          <FormError
            v-if="v.identifier.$error && !v.identifier.required"
            message="Número de documento es requerido"
          />
          <FormError
            v-if="v.identifier.$error && !v.identifier.numeric"
            message="Número de documento debe ser numérico"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Apellido paterno *</label>
          <input
            type="text"
            v-model="form.lastNamePaternal"
            autocomplete="off"
            placeholder="Ingresar apellido paterno"
            class="custom-form-control"
            :class="{ 'custom-form-control-error': v.lastNamePaternal.$error }"
          />
          <FormError
            v-if="v.lastNamePaternal.$error && !v.lastNamePaternal.required"
            message="Apellido paterno es requerido"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Apellido materno</label>
          <input
            type="text"
            v-model="form.lastNameMaternal"
            autocomplete="off"
            placeholder="Ingresar apellido materno"
            class="custom-form-control"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Nombres *</label>
          <input
            type="text"
            v-model="form.name"
            autocomplete="off"
            placeholder="Ingresar nombres"
            class="custom-form-control"
            :class="{ 'custom-form-control-error': v.name.$error }"
          />
          <FormError
            v-if="v.name.$error && !v.name.required"
            message="Nombres son requeridos"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Fecha de nacimiento *</label>
          <FormDatepicker
            label-id="birthDate"
            :show-calendar="showBirthDateCalendar"
            @show="showBirthDateCalendar = true"
            @hidden="showBirthDateCalendar = false"
            v-model="form.birthDate"
          />
          <FormError
            v-if="v.birthDate.$error && !v.birthDate.required"
            message="Fecha de nacimiento es requerida"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Sexo *</label>
          <FormSelect
            id="gender"
            v-model="form.gender"
            :items="genderList"
            defaultOption="Elegir sexo"
            :showError="v.gender.$error && !v.gender.required"
          />
          <FormError
            v-if="v.gender.$error && !v.gender.required"
            message="Sexo es requerido"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Estado civil</label>
          <FormSelect
            id="maritalStatus"
            v-model="form.maritalStatus"
            :items="maritalStatusList"
            defaultOption="Elegir estado civil"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Nacionalidad</label>
          <SearchableDropdown
            placeholder="Elegir nacionalidad"
            :options="nationalityList"
            :oldValue="form.nationality"
            @selected="form.nationality = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Grupo sanguíneo</label>
          <FormSelect
            id="bloodType"
            v-model="form.bloodType"
            :items="bloodTypeList"
            defaultOption="Elegir grupo sanguíneo"
          />
        </div>
      </div>
    </div>

    <!-- Sección Discapacidad -->
    <div class="row mt-2">
      <div class="col-md-12">
        <h2 class="form-subtitle">Discapacidad</h2>
      </div>
      <div class="col-md-12">
        <div class="form-group d-flex align-items-center">
          <label class="mb-0 mr-3">Tiene discapacidad</label>
          <b-form-checkbox
            v-model="form.hasDisability"
            name="hasDisability"
            switch
            size="lg"
          />
        </div>
      </div>

      <template v-if="form.hasDisability">
        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo de discapacidad <span class="text-danger">*</span></label>
            <FormSelect
              id="disabilityType"
              v-model="form.disabilityType"
              :items="disabilityTypeList"
              defaultOption="Elegir tipo"
              :showError="v.disabilityType.$error && !v.disabilityType.required"
            />
            <FormError
              v-if="v.disabilityType.$error && !v.disabilityType.required"
              message="Tipo de discapacidad es requerido"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Nro. certificado CONADIS <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="form.conadisCertificate"
              autocomplete="off"
              placeholder="Ingresar número CONADIS"
              class="custom-form-control"
              :class="{ 'custom-form-control-error': v.conadisCertificate.$error }"
            />
            <FormError
              v-if="v.conadisCertificate.$error && !v.conadisCertificate.required"
              message="Nro. certificado CONADIS es requerido"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { FormError, FormSelect, SearchableDropdown, FormDatepicker } from 'wize-admin'
import { Constants } from '@/core/utils'

export default {
  components: { FormError, FormSelect, SearchableDropdown, FormDatepicker },
  props: {
    form:          { type: Object, required: true },
    v:             { type: Object, required: true },
    districts:     { type: Array,  default: () => [] },
    nationalityList: { type: Array, default: () => [] },
    identifierTypes: { type: Array, default: () => [] },
    genderList:    { type: Array,  default: () => [] },
  },
  data() {
    return {
      showBirthDateCalendar: false,
      maritalStatusList:  Object.values(Constants.MaritalStatus),
      bloodTypeList:      Object.values(Constants.BloodType),
      disabilityTypeList: Object.values(Constants.DisabilityType),
    }
  },
}
</script>

<style lang="stylus" scoped></style>
